import { enableBodyScroll, disableBodyScroll } from "body-scroll-lock";

// Get a target element that you want to persist scrolling for (such as a modal/lightbox/flyout/nav). Specifically, the target element is the one we would like to allow scroll on (NOT a parent of that element). This is also the element to apply the CSS '-webkit-overflow-scrolling: touch;' if desired.
const searchToggles = document.querySelectorAll('.jsToggleSearch');
const searchForm = document.querySelector('.jsSearchForm');
const searchField = document.querySelector('#search-form__search');

export function search()
{
	searchToggles.forEach(searchToggle =>
	{
		searchToggle.addEventListener('click', searchToggleHandler);
	})

	// Close search dialog if ESC is pressed
	document.addEventListener('keyup', function (e)
	{
		if (e.key == "Escape")
		{
			closeSearchDialog();
		}
	});
}

function searchToggleHandler()
{
	const searchFormState = document.documentElement.classList.toggle('search-is-shown');
	if (searchFormState)
	{
		disableBodyScroll(searchForm);
		searchField.focus();
	}
	else
	{
		enableBodyScroll(searchForm);
	}
}

function closeSearchDialog()
{
	const searchFormState = document.documentElement.classList.remove('search-is-shown');
	searchFormState ? disableBodyScroll(searchForm) : enableBodyScroll(searchForm);
}